import React, { createElement, useState } from 'react';
import { Comment, Tooltip, Avatar } from 'antd';
import moment from 'moment';
import { DislikeOutlined, LikeOutlined, DislikeFilled, LikeFilled } from '@ant-design/icons';
import "./chat-message.scss";

const ChatMessage = ({ author, msg, date, likeOrNot , imgAvatar }) => {
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [action, setAction] = useState(null);

  const like = () => {
    setLikes(1);
    setDislikes(0);
    setAction("liked");
  };

  const dislike = () => {
    setLikes(0);
    setDislikes(1);
    setAction("disliked");
  };

  const actions = [
    <span key="comment-basic-reply-to">رد</span>,
  ];


  return (
    <Comment
      actions={actions}
      author={author}
      className="comment-container"
      avatar={
        <Avatar
          src={imgAvatar}
          alt={author}
        />
      }
      content={<p>{msg}</p>}
  
      datetime={
        <Tooltip title={moment().format("YYYY-MM-DD HH:mm:ss")}>
          <span>{date}</span>
        </Tooltip>
      }
    />
  );
};

export default ChatMessage;
